import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import VerifyAddressForm from './VerifyAddressForm';
import { bindActionCreators } from 'redux';
import fetchDux from '../../../state/fetch-dux';
const VerifyAddressModal = (
    {
        openModal,
        onHide,
        result,
        lookups,
        closeModal,
        waitlist,
        joinWaitList,
        inProgress,
        error
    }
) => {
    const { AddressBook } = result || {};
    return (
        <Modal show={openModal === 'VerifyAddressModal'} size="lg" onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Verify Address</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <VerifyAddressForm
                    onSubmit={(values) => {
                        const payload = { ...values, wailtListClubTypeId: waitlist }
                        joinWaitList(payload, null, null, (result) => {
                            const { success } = result || {};
                            if (success) {
                                closeModal('VerifyAddressModal');
                            }
                        });
                    }}
                    AddressBook={AddressBook}
                    lookups={lookups}
                    onCancel={closeModal}
                    inProgress={inProgress}
                />
                {
                    error && (
                        <h5 style={{ color: '#dc3545' }}>{error.message}</h5>
                    )
                }
            </Modal.Body>
        </Modal>
    )


}

const mapState = state => {
    const {
        result
    } = state.postLogin.toJS();

    const {
        result: joinWaitListResult,
        inProgress,
        error,
    } = state.joinWaitList.toJS();

    return {
        openModal: state.modals,
        result,
        joinWaitListResult,
        inProgress,
        error
    }
}

const mapDispatch = dispatch =>
    bindActionCreators({
        joinWaitList: fetchDux.joinWaitList.createAction
    }, dispatch)

export default connect(mapState, mapDispatch)(VerifyAddressModal);